function SearchPage({
  searchTerm,
  setSearchTerm,
  filteredSearchBlogs,
  normalizedSearchTerm,
  paginatedSearchBlogs,
  getSnippet,
  openPost,
  totalSearchPages,
  searchPage,
  setSearchPage,
}) {
  return (
    <main className="main search-main">
      <section className="search-shell">
        <p className="search-kicker">Explore Blog Titles</p>
        <h1>Search Posts By Keywords</h1>
        <p>
          Type any words from your blog titles. Matching posts will appear below in
          a clean, paginated grid.
        </p>

        <div className="search-input-wrap">
          <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
            <path
              d="M10.5 4.5a6 6 0 1 1 0 12a6 6 0 0 1 0-12Zm0-2a8 8 0 1 0 4.9 14.3l5 5a1 1 0 1 0 1.4-1.4l-5-5A8 8 0 0 0 10.5 2.5Z"
              fill="currentColor"
            />
          </svg>
          <input
            type="text"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Search blog title words (e.g. fitness, dashboard, portfolio)"
            aria-label="Search blog title words"
          />
        </div>

        <p className="search-meta">
          {filteredSearchBlogs.length} result{filteredSearchBlogs.length === 1 ? "" : "s"}
          {normalizedSearchTerm ? ` for "${searchTerm.trim()}"` : ""}
        </p>

        {paginatedSearchBlogs.length > 0 ? (
          <section className="search-grid">
            {paginatedSearchBlogs.map((blog) => (
              <article className="search-card" key={blog.id}>
                {(blog.bannerImage || blog.images?.[0]) && (
                  <img
                    className="blog-cover"
                    src={blog.bannerImage || blog.images[0]}
                    alt={blog.title}
                    loading="lazy"
                    style={{
                      objectPosition: blog.bannerImage
                        ? `${blog.bannerFocusX ?? 50}% ${blog.bannerFocusY ?? 50}%`
                        : `${blog.imageFocusX ?? 50}% ${blog.imageFocusY ?? 50}%`,
                    }}
                  />
                )}
                <p className="blog-date">
                  {blog.updatedAt
                    ? `Updated ${new Date(blog.updatedAt).toLocaleDateString()}`
                    : `Published ${new Date(blog.createdAt).toLocaleDateString()}`}
                </p>
                <h2>{blog.title}</h2>
                <p>{getSnippet(blog.content)}</p>
                <button
                  className="btn-secondary read-btn"
                  type="button"
                  onClick={() => openPost(blog.id)}
                >
                  Read full post
                </button>
              </article>
            ))}
          </section>
        ) : (
          <div className="search-empty">
            <h3>No matches yet</h3>
            <p>Try another keyword from a title you have used in your posts.</p>
          </div>
        )}

        {totalSearchPages > 1 && (
          <div className="pagination">
            <button
              className="btn-secondary page-btn"
              type="button"
              onClick={() => setSearchPage((value) => Math.max(1, value - 1))}
              disabled={searchPage === 1}
            >
              Previous
            </button>
            {Array.from({ length: totalSearchPages }, (_, index) => index + 1).map((value) => (
              <button
                key={value}
                className={`btn-secondary page-btn ${value === searchPage ? "active" : ""}`}
                type="button"
                onClick={() => setSearchPage(value)}
              >
                {value}
              </button>
            ))}
            <button
              className="btn-secondary page-btn"
              type="button"
              onClick={() => setSearchPage((value) => Math.min(totalSearchPages, value + 1))}
              disabled={searchPage === totalSearchPages}
            >
              Next
            </button>
          </div>
        )}
      </section>
    </main>
  );
}

export default SearchPage;
